import React from 'react';
import styled from 'styled-components';
import { NavigationLeftAlternate } from '@dls/react-icons';
import { ColorDLS } from '../../styling/color';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@dls/react-core';
import { StyledHeaderContainer } from './styles';

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledItemsContainer = styled.div`
  display: flex;
  margin-left: 32px;

  span:not(:first-child) {
    margin-left: 24px;
  }

  p:not(:first-child) {
    margin-left: 8px;
  }
`;

const StyledItem = styled.span`
  display: flex;
`;

interface BackNavigationHeaderProps {
  navigateTo: string;
  children?: React.ReactNode;
  menu?: React.ReactNode;
  title?: string | React.ReactNode;
  properties?: Record<string, number | string | undefined>;
}

export const BackNavigationHeader: React.FC<BackNavigationHeaderProps> = ({
  navigateTo,
  children,
  menu: optionalMenu,
  title,
  properties,
}) => {
  const navigate = useNavigate();
  return (
    <StyledHeaderContainer>
      <StyledContainer>
        <NavigationLeftAlternate
          height={24}
          width={24}
          fill={ColorDLS.Gray75}
          margin="4px"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate(navigateTo)}
        />
        {typeof title === 'string' ? (
          <Typography className={`mb0 ml16`} variant="h3">
            {title}
          </Typography>
        ) : (
          title
        )}
        {properties && (
          <StyledItemsContainer>
            {Object.entries(properties).map(([k, v]) => {
              return (
                <StyledItem key={k}>
                  <Typography className={`mb0`} variant="body2" extra_color="tertiary">
                    {k}
                  </Typography>
                  <Typography className={`mb0`} variant="body2">
                    {v}
                  </Typography>
                </StyledItem>
              );
            })}
          </StyledItemsContainer>
        )}
        {children}
      </StyledContainer>
      {optionalMenu}
    </StyledHeaderContainer>
  );
};
